import React from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import webify from "../util/webify"

import { formatDate, parseDate } from "../util/date"

import { format, formatISO, parse, parseISO, isValid } from "date-fns"

const FORMAT = "M/d/yy"

interface Props {
  name: string
  value?: string
  className?: string
  fromYear?: number
  toYear?: number
  month?: Date
  disabledDays?: any
  modifiers?: any
  "data-role"?: string
  onChange?: (string) => void
}

interface State {
  date: string
}

class DatePicker extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      date: props.value ? format(parseISO(props.value), FORMAT) : "",
    }
  }

  changeDay = (day, _, input) => {
    this.setState({ date: input.input.value })
    if (this.props.onChange) {
      this.props.onChange(day)
    }
  }

  dayPickerProps = () => {
    let dayPickerProps: any = {}

    if (this.props.fromYear && this.props.toYear) {
      const { fromYear, toYear } = this.props

      dayPickerProps.fromMonth = new Date(fromYear - 1, 12, 31)
      dayPickerProps.toMonth = new Date(toYear, 12, 31)
    }
    dayPickerProps.disabledDays = this.props.disabledDays
    dayPickerProps.modifiers = this.props.modifiers
    dayPickerProps.month = this.props.month
    return dayPickerProps
  }

  isoDate = () => {
    let date = this.state.date && parse(this.state.date, FORMAT, new Date())

    if (date && isValid(date)) {
      return formatISO(date, { representation: "date" })
    } else {
      return ""
    }
  }

  render() {
    return (
      <div data-role={this.props["data-role"]}>
        <input type="hidden" name={this.props.name} value={this.isoDate()} />
        <DayPickerInput
          format={FORMAT}
          placeholder={format(new Date(), FORMAT)}
          formatDate={formatDate}
          parseDate={parseDate}
          value={this.state.date}
          onDayChange={this.changeDay}
          dayPickerProps={this.dayPickerProps()}
          inputProps={{
            className: `${this.props.className || ""} form-control date-picker`,
            "data-role": "internal-input",
            pattern: "\\d\\d?/\\d\\d?/\\d\\d",
            title: `Please format dates like this: ${format(new Date(), FORMAT)}`,
            type: "text",
          }}
        />
      </div>
    )
  }
}

export default DatePicker

webify("date-picker", DatePicker)
